import { defaultBackgrounds } from '@/config/predefinedCardAssets';
import React from 'react';
const BackgroundImageGallery = ({ onSelect }) => {
  // Remove base64 conversion here and just pass the URL
  const handleImageSelect = (imageUrl) => {
    onSelect(imageUrl);
  };

  return (
    <div className="grid grid-cols-1 gap-2">
      {defaultBackgrounds.map((bg) => (
        <button
          key={bg.id}
          className="relative aspect-video rounded-lg overflow-hidden border-2 hover:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
          onClick={() => handleImageSelect(bg.url)}
        >
          <img
            src={bg.thumbnail}
            alt={`Background ${bg.id}`}
            className="w-full h-full object-cover"
          />
        </button>
      ))}
    </div>
  );
};

export default BackgroundImageGallery;
